import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import map from 'lodash/map';
import { GlobalFooter } from '@nexus/fff-global-footer';

import withViewSize from 'HOC/withViewSize/withViewSize';
import { selectPageTrackingData } from 'selectors/trackingSelector';

import copyToClipboard from 'utils/copyToClipboard';
import env from 'utils/env';
import { GlobalNav } from '@nexus/fff-global-nav';
import OfferCard from './OfferCard';
import getOffers from './OfferModelCDN';
import styles from './ExclusiveOffers.module.css';

const ExclusiveOffers = ({ viewSize, trackingData }) => {
  const [copiedCode, setCopiedCode] = useState(null);
  const [offersData, setOffersData] = useState([]);
  const isDesktop = viewSize === 'xLarge';

  const handleCopyToClipboard = (id, code) => {
    copyToClipboard(code);
    setCopiedCode(id);
  };

  useEffect(() => {
    const fetchOffers = async () => {
      const offers = await getOffers();
      setOffersData(offers);
    };
    fetchOffers();
  }, []);

  return (
    <div className={viewSize}>
      <div className={styles.navWrapper}>
        <GlobalNav env={env.appEnv} />
      </div>
      <div>
        <div className={styles.header}>
          <h1>Exclusive Offers*</h1>
          <p>Snag some amazing deals from our favorite brands!</p>
        </div>
        <div>
          <ul className={styles.offersGrid}>
            {map(offersData, (offer) => (
              <OfferCard
                key={offer.offerId}
                offer={offer}
                isDesktop={isDesktop}
                trackingData={trackingData}
                onCopyCode={handleCopyToClipboard}
                copiedCode={copiedCode === offer.offerId}
              />
            ))}
          </ul>
        </div>
      </div>
      <div className={styles.legalNote}>
        *These offers are intended as promotions only and only have promotional
        value. These offers are not included in the value of your box. The sale
        of these promotions or use for unauthorized advertising, marketing,
        sweepstakes or other purposes is strictly prohibited. Each merchant is
        solely responsible to purchasers for the care and quality of the
        advertised goods and services. For more information of these types of
        offers please visit our&nbsp;
        <a
          href="https://fabfitfun.com/terms-use-sale/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Terms of Use and Sale.
        </a>
      </div>
      <GlobalFooter />
    </div>
  );
};

const mapStateToProps = (state) => ({
  viewSize: state.viewState.viewSize,
  trackingData: selectPageTrackingData(state),
});

export default compose(withViewSize, connect(mapStateToProps))(ExclusiveOffers);
